import {Component, OnChanges, OnInit, ViewChild} from '@angular/core';
import {LeadSource} from '../../model/lead-source';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {AutofocusDirective} from '../../autofocus.directive';
import {LeadSourcesResource} from '../../model/model-resource';
import {ActivatedRoute, ParamMap, Router} from '@angular/router';

@Component({
  selector: 'app-lead-source-page',
  templateUrl: './lead-source-page.component.html',
  styleUrls: ['./lead-source-page.component.scss']
})
export class LeadSourcePageComponent implements OnInit, OnChanges {

  leadSource: LeadSource;
  form: UntypedFormGroup;
  editMode = false;

  @ViewChild(AutofocusDirective) focus: AutofocusDirective;

  constructor(private resource: LeadSourcesResource,
              private builder: UntypedFormBuilder,
              private route: ActivatedRoute,
              private router: Router) {
    this.form = this.builder.group({
      name: ['', Validators.required]
    });
  }

  editLeadSource() {
    this.editMode = true;
    this.focus.focus();
  }

  revertLeadSource() {
    this.ngOnChanges();
    if (this.leadSource.isNew()) {
      this.router.navigate(['/settings/lead-sources']);
    }
  }

  saveLeadSource() {
    const formModel = this.form.value;
    const leadSource = this.leadSource.clone();
    leadSource.name = formModel.name;
    this.resource.save(leadSource).subscribe((saved) => {
      this.leadSource = saved;
      this.ngOnChanges();
    });
  }

  ngOnInit() {
    this.route.paramMap.subscribe((params: ParamMap) => {
      if (params.has('leadSourceId')) {
        this.resource.get(+params.get('leadSourceId')).subscribe(leadSource => {
          this.leadSource = leadSource;
          this.ngOnChanges();
        });
      } else {
        this.leadSource = new LeadSource();
        this.ngOnChanges();
      }
    });
  }

  ngOnChanges() {
    if (this.leadSource) {
      this.editMode = false;
      this.form.reset();
      this.form.patchValue(this.leadSource);
      if (this.leadSource.isNew()) {
        this.editMode = true;
        //this.focus.focus();
      }
    }
  }
}
